__turbopack_context__.v({
  "className": "noto_sans_tc_15b38a14-module__7pvmkq__className",
});
